var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBellIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 79,
  height: 76,
  viewBox: "0 0 79 76",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M59.3345 25.5832C59.3345 20.5852 57.2627 15.7919 53.5749 12.2578C49.8872 8.72372 44.8855 6.73828 39.6702 6.73828C34.4549 6.73828 29.4532 8.72372 25.7655 12.2578C22.0777 15.7919 20.006 20.5852 20.006 25.5832C20.006 47.5689 10.1738 53.8506 10.1738 53.8506H69.1666C69.1666 53.8506 59.3345 47.5689 59.3345 25.5832Z",
  stroke: "#1A21BA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M45.3402 66.416C44.764 67.3679 43.937 68.1581 42.9419 68.7073C41.9468 69.2566 40.8187 69.5457 39.6703 69.5457C38.522 69.5457 37.3938 69.2566 36.3988 68.7073C35.4037 68.1581 34.5767 67.3679 34.0005 66.416",
  stroke: "#1A21BA",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBellIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell-icon.fe28c418.svg";
export { ForwardRef as ReactComponent };